<template>
  <div>
    <div class="col-12">
      <div>
        <Catalogo
          :dataCatalogo="dataCatalogo"
          :isLoading="isLoading"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Message from '@/components/shared/mixins/Message.js';
import Validation from '@/components/shared/mixins/Validation.js';
import Catalogo from '../components/Catalogo.vue';
import { v4 as uuidv4 } from 'uuid';

export default {
  components: {
    Catalogo
  },
  mixins: [Message, Validation],
  data: function () {
    return {
      dataCatalogo: [],
      isLoading: false,
      isAdmin: false
    };
  },
  mounted () {
    this._callData();
  },
  computed: {},
  methods: {
    async _callData () {
      let request = {};
      this.isAdmin = this.$store.getters['PF/isSuperAdmin'];

      this.isLoading = true;
      request = {
        controller: '/Catalogo'
      };

      await this.$store
        .dispatch('PF/getSuit', request)
        .then(response => {
          this.dataCatalogo = this.filterCatalogo(response.data);
          this.isLoading = false;
        })
        .catch(err => {
          this.showError(err.message);
          this.isLoading = false;
        });
    },
    filterCatalogo (catalogo) {
      let dataCatalogoFiltrado = [];
      catalogo.forEach(ambito => {
        let ambitoActual = {
          id: uuidv4(),
          name: ambito.name,
          tematicas: []
        };
        ambito.verticales.forEach(vertical => {
          vertical.tematicas.map(tematica => {
            let tematicaLocal = {
              id: uuidv4()
            };

            tematica = Object.assign(tematicaLocal, tematica);
            ambitoActual.tematicas.push(tematica);
          });
        });
        dataCatalogoFiltrado.push(ambitoActual);
      });

      return dataCatalogoFiltrado;
    }
  }
};
</script>
